import { joinNotEmpty } from 'app/utils/string.utils';

export class AddressApiModel {
  addressId?: number;
  city: string;
  street: string;
  buildingNumber: string;
  officeNumber?: string;
  postalNumber: string;
  geoLocation: string;
  countryId?: number;
  region: string;
  note?: string;
  customerId?: number;
  customerName: string;
  customerKey: string;
}

export class AddressModel extends AddressApiModel {
  formattedAddress?: string;
  country?: string;
}

export class ParsedAddress {
  googleResults?: google.maps.GeocoderResult[];
  result: AddressApiModel;
}

export class AddressFormatter {
  static format(item: any): string {
    const streetText = joinNotEmpty([item.street, item.buildingNumber]);
    const cityCountryText = joinNotEmpty([
      item.postCode,
      item.city,
      item.country,
    ]);
    return joinNotEmpty([streetText, cityCountryText], ', ');
  }
  static formatStreet(item: any): string {
    return joinNotEmpty([item.street, item.buildingNumber]);
  }
}
